import { Box } from '@mui/material';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProcessPage from '../components/pages/ProcessPage';
import TrackIntroducePage from '../components/pages/TrackIntroducePage';
import TraineeBenefitsPage from '../components/pages/TraineeBenefitsPage';

const Education = () => {
  return <Box>Education</Box>;
};
const EducationProcessPlan = () => {
  return (
    <Box>
      <ProcessPage />
    </Box>
  );
};
const TrackIntroduce = () => {
  return (
    <Box>
      <TrackIntroducePage />
    </Box>
  );
};
const TraineeBenefits = () => {
  return (
    <Box>
      <TraineeBenefitsPage />
    </Box>
  );
};

export default function EducationRouter() {
  return (
    <Routes>
      <Route path='/' element={<Education />} />
      <Route path='/process' element={<EducationProcessPlan />} />
      <Route path='/track' element={<TrackIntroduce />} />
      <Route path='/trainee' element={<TraineeBenefits />} />
    </Routes>
  );
}
